module.exports = "//The 12hr format\n<TimePicker\n  format=\"ampm\"\n  hintText=\"12hr Format\" />\n\n//The 24hr format\n<TimePicker\n  format=\"24hr\"\n  hintText=\"24hr Format\" />\n\n//Auto OK\n<TimePicker\n  hintText=\"AutoOk\"\n  autoOk={true} />\n\n//Override TextField/Input Style\n<TimePicker\n  format=\"24hr\"\n  hintText=\"Override text field style\"\n  textFieldStyle={{ fontSize: 'x-large' }} />\n\n//Override Container/Root Element Style\n<TimePicker\n  hintText=\"Override style\"\n  textFieldStyle={{ width: '80%' }}\n  style={{ padding: '5px', borderRadius: '5px', backgroundColor: '#d1d1d1' }} />\n"


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/components/raw-code/time-picker-code.txt
 ** module id = 883
 ** module chunks = 0
 **/